import { SHOW_WARNING_BANNER } from "../../constants";

export const dismissWarningBanner = () => dispatch => {
  dispatch({
    type: SHOW_WARNING_BANNER,
    payload: { showWarningBanner: false }
  });
};
